import { defineComponent, h, VNodeChildren } from 'vue';
// @ts-ignore
import { BRadio } from 'buefy/dist/esm/radio';
import { SetterCallback } from '@/ui/types';

interface RadioProps {
  value: string;
  name: string;
  nativeValue: string;
}

export const Radio = defineComponent<RadioProps>({
  props: ['value', 'name', 'nativeValue'],
  setup(props, context) {
    return function render() {
      return h(BRadio, {
        props,
        on: {
          input: (newValue: unknown) => {
            context.emit('input', newValue);
          },
        },
      }, [context.slots.default?.()]);
    };
  },
});

export function radio<T = string>(props: RadioProps, input: SetterCallback<T>, content: VNodeChildren) {
  return h(Radio, { props, on: { input } }, content);
}
